import $ from 'jquery';
import Swiper, {Navigation, Pagination, EffectFade, Scrollbar} from 'swiper';

$(function() {

    Swiper.use([Navigation, Pagination, EffectFade, Scrollbar]);

    // Testimonial swiper
    new Swiper('.js-swiper-testimonials', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
        breakpoints: {
            0: {
                autoHeight: true,
            },
            991: {
                autoHeight: false,
            }
        }
    });

    // Image Carousel CMS row swiper
    new Swiper('.js-swiper-image-carousel', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            500: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 45,
            }
        }
    });

    // Card Carousel CMS row swiper
    new Swiper('.js-swiper-card-carousel', {
        slidesPerView: 3,
        spaceBetween: 45,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 45,
            },
            991: {
                slidesPerView: 3,
            }
        }
    });

});
